import type React from 'react';
import { createContext } from 'react';

import {
  type FormatType,
  type ListTypeEnum,
  type Option,
} from 'components/panels/eventsSplitDraws/selectedEvent/rankingsAndRatings/types';
import type RankingsAndRatingsService from 'services/rankingsAndRatings/rankingsAndRatingsService';
import { RankingsAndRatingsServiceImpl } from 'services/rankingsAndRatings/rankingsAndRatingsServiceImpl';

export interface RankingsAndRatingsContextProps {
  getRankingsListData?: any; // TODO: add proper type - by vuk_niko
  getRankingsListLoading?: any; // TODO: add proper type - by vuk_niko
  rankingsConfig?: {
    availableDates: Option[];
    format: string;
    formatType: FormatType;
    gender: string;
    isDoubles: boolean;
    isFamily: boolean;
    familyCategory: string | null;
    isWheelchair: boolean;
    wheelchairRating: string | null;
    isJunior: boolean;
    isNTRP: boolean;
    isNtrpCombo: boolean;
    isMixed: boolean;
    listType: ListTypeEnum;
    loadingList: boolean;
    selectedPublishDate: string;
    setFormat: React.Dispatch<React.SetStateAction<string>>;
    setFormatType: React.Dispatch<React.SetStateAction<FormatType>>;
    setListType: React.Dispatch<React.SetStateAction<ListTypeEnum>>;
    setGender: React.Dispatch<React.SetStateAction<string>>;
    setLoadingList: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedPublishDate: React.Dispatch<React.SetStateAction<string>>;
  };
  getRankingList?(id?: string, resetOffset?: boolean): any; // TODO: add proper type - by vuk_niko
  getRankingsList?(listTypeVal?: string, formatVal?: string, formatTypeVal?: string, genderVal?: string): any; // TODO: add proper type - by vuk_niko
  getRankingsAndRatings?(): void;
  getWtnRating?(): void;
  getPtPoints?(): void;
}

export const RankingsAndRatingsContext = createContext<RankingsAndRatingsContextProps>(null);
export const RankingsAndRatingsServiceContext = createContext<RankingsAndRatingsService>(
  new RankingsAndRatingsServiceImpl(),
);
